import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/Layout.vue";

import storeManager from "./routes/store-manager";
import areaManager from "./routes/area-manager";
import common from "./routes/common";
import customer from "./routes/customer";
import sa from "./routes/sa";
import { USER_ROLES } from "@/consts";
import store from "@/store";
import config from "@conf";
import { isWxWork } from "@/utils";

const packageJson = require("../../package.json");

const guestPages = [
  "Authorization",
  "Forbidden",
  "PaySuccess",
  "PrivacyRules",
  "SalesRules",
  "AuthPrompt",
  "Debug",
];
const setTitle = (title) => {
  if (!title) return;
  // 如果设置标题，拦截后设置标题
  document.title = title;
};

const redirectIfNeedSelectStore = (name, next) => {
  const { currentStore } = store.getters;
  if (currentStore) {
    next({ name, replace: true });
  } else {
    next({ name: "SelectStore", replace: true });
  }
};
const resolveRootPath = ({ role }, to, from, next) => {
  switch (role) {
    case USER_ROLES.CLIENT_AGENT:
      return redirectIfNeedSelectStore("SADashboard", next);

    case USER_ROLES.STORE_MANAGER:
      return redirectIfNeedSelectStore("StoreManagerDashboard", next);

    case USER_ROLES.REGION_MANAGER:
      return next({ name: "AreaManagerDashboard", replace: true });

    default:
      console.log("No Permission to Access");
      next({ name: "Forbidden", replace: true });
  }
};
const resolveRolelessPath = ({ user }, to, from, next) => {
  if (config.isProduction && isWxWork) {
    if (to.name === "CustomerOrder" && user.caPosition) {
      return next({
        name: "Order",
        replace: true,
        query: to.query,
      });
    }
  }
  return next();
};
const resolveWithRolePath = ({ role, user }, to, from, next) => {
  if (role === USER_ROLES.STORE_MANAGER) {
    if (user.store && !user.store.name && user.isMoreStore) {
      return next({
        name: "SelectStore",
        query: {
          from: encodeURIComponent(to.path),
        },
        replace: true,
      });
    }
  }
  return next();
};

Vue.use(Router);
const router = new Router({
  mode: "hash",
  base: `/${packageJson.name}`,
  routes: [
    {
      path: "/",
      name: "Layout",
      component: Layout,
      meta: {},
      children: [...common, customer, sa, storeManager, areaManager],
    },
    {
      path: "/auth",
      component: () =>
        import(
          /* webpackChunkName: "Authorization" */ "@/views/Auth/Authorization.vue"
        ),
      name: "Authorization",
      meta: { title: "" },
    },
    {
      path: "/privacy-rules",
      name: "PrivacyRules",
      component: () =>
        import(
          /* webpackChunkName: "Forbidden" */ "@/views/Customer/PrivacyRules.vue"
        ),
      meta: { title: "隐私条款" },
    },
    {
      path: "/sales-rules",
      name: "SalesRules",
      component: () =>
        import(
          /* webpackChunkName: "Forbidden" */ "@/views/Customer/SalesRules.vue"
        ),
      meta: { title: "销售条款" },
    },
    {
      path: "/403",
      component: () =>
        import(
          /* webpackChunkName: "Forbidden" */ "@/views/Auth/Forbidden.vue"
        ),
      name: "Forbidden",
      meta: { title: "" },
    },
    {
      path: "/debug",
      component: () =>
        import(/* webpackChunkName: "Forbidden" */ "@/views/Debug.vue"),
      name: "Debug",
      meta: { title: "Debug" },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const { name, path, meta, query } = to;
  const { title, accessRoles } = meta || {};
  console.log("[ Before Route ]", { title, name, accessRoles, path, query });

  setTitle(title);
  // return next();
  if (guestPages.includes(to.name)) {
    return next();
  }

  await store.accountReady();
  const {
    user,
    account: { role },
  } = store.state;

  console.log("[ After Store Ready ]", { user, role });
  console.log('======resolveRootPath', to, from, next)
  if (to.path == "/") {
    return resolveRootPath({ role }, to, from, next);
  }
  if (!accessRoles?.length) {
    return resolveRolelessPath({ user }, to, from, next);
  }

  if (accessRoles.includes(role)) {
    return resolveWithRolePath({ role, user }, to, from, next);
  }
  resolveRootPath({ role }, to, from, next);
});

export default router;
